import React, { useCallback, useRef, useState, useEffect } from 'react';
import { FormHandles } from '@unform/core';
import UndoIcon from '@material-ui/icons/ArrowBackIos';
import * as Yup from 'yup';
import { useHistory, Link, useParams } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { Box, Tab, Tabs } from '@material-ui/core';
import Select from '../../../../components/Inputs/Select';
import getValidationErrors from '../../../../utils/getValidationErrors';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/toast';
import BotaoSalvar from '../../../../components/Botoes/BotaoSalvar';
import Input from '../../../../components/Inputs/Input';
import { Container } from '../../../../styles/GlobalStyles';
import Loading from '../../../../components/Loading';
import {
  HeaderCadastro,
  BodyCadastro,
  FooterCadastro,
  Voltar,
  FormContainer,
  ContainerBaseDados,
  ContainerdadosGerais,
  ObservacaoTexto,
} from './styles';
import { status, tipo_sincronizacao } from '../../../../config/Basicos';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Usuarios from './components/usuarios';
import OAuthConnector from './components/OAuthConnector';
import SincronizacaoEntidades from './components/SincronizacaoEntidades';

interface IUsuario {
  id: number;
  nome: string;
  email: string;
  status_acesso: string;
  ativo: boolean;
  full_access?: boolean;
  verificado?: boolean;
  roles: {
    id?: number;
    nome: string;
    empresa_id: number;
  }[];
}

interface IEmpresa {
  id: number;
  nome: string;
}

interface IAccount {
  status: boolean;
  nome: string;
  host: string | null;
  database: string | null;
  username: string | null;
  password: string | null;
  profile: number | null;
  sincronizar?: boolean;
  notificar_falha_sincronizacao?: boolean;
  ativo?: boolean;
  max_users?: number;
  contract_token?: string;
  tipo_sincronizacao?: string;
  conectado_api: boolean;
  dias_previsao_estoque?: number | null;
}

interface IRouteParam {
  id?: string;
}

type TipoSincronizacao = 'sync4' | 'api_beersales';

const ABA_SINCRONIZACAO = 3;

// A aba de sincronização é ferramenta de suporte: fica oculta e é revelada por
// Ctrl+Alt+S (Cmd+Alt+S no mac). A escolha guarda na sessão para sobreviver ao
// salvar o cadastro; fechar a aba do navegador volta a esconder.
const CHAVE_ABA_SINCRONIZACAO = 'fv:admin:aba-sincronizacao';

const CadastroAccounts: React.FC<IRouteParam> = () => {
  const { id } = useParams<IRouteParam>();
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const { addToast } = useToast();
  const history = useHistory();
  const [loading_message, setLoadingMessage] = useState('');
  const [usuarios, setUsuarios] = useState<IUsuario[]>([]);
  const [empresas, setEmpresas] = useState<IEmpresa[]>([]);
  const [tipoSincronizacao, setTipoSincronizacao] = useState<TipoSincronizacao>(
    tipo_sincronizacao[0].value,
  );
  const [total_usuarios_contratados, setTotalUsuariosContratados] =
    useState<number>();
  const mounted = useRef(false);
  const [profile, setProfile] = useState<number | null>(null);
  const profiles_types =
    profile !== 0
      ? [
          { value: 1, label: 'BS - Teste' },
          { value: 2, label: 'BS - Produção' },
        ]
      : [{ value: 0, label: 'Gratuito' }];
  const [tabIndex, setTabIndex] = useState(0);
  const [mostrarSincronizacao, setMostrarSincronizacao] = useState(
    () => sessionStorage.getItem(CHAVE_ABA_SINCRONIZACAO) === '1',
  );

  useEffect(() => {
    const alternarAbaSincronizacao = (evento: KeyboardEvent) => {
      // code em vez de key: com Alt pressionado o key muda conforme o layout
      // (no mac, Alt+S vira "ß"), enquanto o code permanece KeyS.
      if (
        !(evento.ctrlKey || evento.metaKey) ||
        !evento.altKey ||
        evento.code !== 'KeyS'
      ) {
        return;
      }

      evento.preventDefault();

      const revelar = sessionStorage.getItem(CHAVE_ABA_SINCRONIZACAO) !== '1';

      if (revelar) {
        sessionStorage.setItem(CHAVE_ABA_SINCRONIZACAO, '1');
      } else {
        sessionStorage.removeItem(CHAVE_ABA_SINCRONIZACAO);
        // Sem isso o conteúdo desaparece mas a aba segue selecionada.
        setTabIndex(indice => (indice === ABA_SINCRONIZACAO ? 0 : indice));
      }

      setMostrarSincronizacao(revelar);
    };

    window.addEventListener('keydown', alternarAbaSincronizacao);

    return () =>
      window.removeEventListener('keydown', alternarAbaSincronizacao);
  }, []);

  // Adiciona este estado para armazenar dados do formulário
  const [formData, setFormData] = useState<IAccount>({
    status: true,
    nome: '',
    host: null,
    database: null,
    username: null,
    password: null,
    profile: 2,
    sincronizar: true,
    notificar_falha_sincronizacao: false,
    ativo: true,
    max_users: 0,
    contract_token: '',
    tipo_sincronizacao: tipo_sincronizacao[0].value,
    conectado_api: false,
    dias_previsao_estoque: null,
  });

  const handleTabChange = (_: React.ChangeEvent<{}>, newIndex: number) => {
    // Salva os dados atuais do formulário antes de mudar de aba
    if (formRef.current) {
      const currentData = formRef.current.getData();
      setFormData(prevData => ({ ...prevData, ...currentData }));
    }

    // Só permite mudar para as abas de conexão, usuários e sincronização se houver um ID
    if (newIndex !== 0 && !id) {
      return;
    }

    setTabIndex(newIndex);
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  useEffect(() => {
    const currentData = formRef.current?.getData();

    if (currentData?.tipo_sincronizacao !== formData.tipo_sincronizacao) {
      formRef.current?.setData({
        ...currentData,
        host: null,
        database: null,
        username: null,
        password: null,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formRef.current?.getData(), formData.tipo_sincronizacao]);

  useEffect(() => {
    async function getAccount(): Promise<void> {
      if (!id) return;
      setIsLoading(true);
      try {
        const { data } = await api.get<IAccount>(`/admin/account/${id}`);
        if (mounted.current) {
          setProfile(data.profile);
          if (data.tipo_sincronizacao) {
            setTipoSincronizacao(data.tipo_sincronizacao as TipoSincronizacao);
          } else {
            setTipoSincronizacao(
              tipo_sincronizacao[0].value as TipoSincronizacao,
            );
          }
          setFormData(data);
          formRef.current?.setData(data);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('Erro ao carregar conta:', error);
        if (mounted.current) {
          setIsLoading(false);
        }
      }
    }

    getAccount();
  }, [id]);

  useEffect(() => {
    if (formRef.current && formData) {
      formRef.current.setData(formData);
      // Garante que tipoSincronizacao está sincronizado com formData
      if (formData.tipo_sincronizacao && tabIndex === 1) {
        setTipoSincronizacao(formData.tipo_sincronizacao as TipoSincronizacao);
      }
    }
  }, [tabIndex, formData]);

  useEffect(() => {
    async function getUsuarios(): Promise<void> {
      if (!id) return;
      const { data } = await api.get<IUsuario[]>(`/admin/user/${id}`);
      if (mounted.current) setUsuarios(data);
    }
    getUsuarios();
  }, [id]);

  useEffect(() => {
    async function getEmpresas(): Promise<void> {
      if (!id) return;
      const { data } = await api.get<IEmpresa[]>(
        `admin/empresas-from-account/${id}`,
      );
      if (mounted.current) setEmpresas(data);
    }
    getEmpresas();
  }, [id]);

  useEffect(() => {
    async function getUsuariosContratados(): Promise<void> {
      if (!id) return;
      const { data } = await api.get(`/admin/user-total-contratados/${id}`);
      if (mounted.current) setTotalUsuariosContratados(data);
    }
    getUsuariosContratados();
  }, [id]);

  const handleSubmit = useCallback(
    async (data: IAccount) => {
      setIsLoading(true);
      try {
        setLoadingMessage('Salvando...');
        formRef.current?.setErrors({});

        // Combina com dados existentes do formulário
        const mergedData = { ...formData, ...data };

        // Schema básico para validação (campos da primeira aba)
        const baseSchema = {
          nome: Yup.string()
            .required('O nome da empresa é obrigatório')
            .max(100, 'O nome da empresa não pode ter mais de 100 caracteres'),
          max_users: Yup.number()
            .required('Informe a quantidade')
            .max(99999999, 'Informe um número válido'),
          contract_token: Yup.string()
            .required('O token é obrigatório')
            .max(100, 'O token não pode ter mais de 255 caracteres'),
          profile: Yup.number()
            .min(1, 'O Perfil escolhido está incorreto')
            .max(2, 'O Perfil escolhido está incorreto')
            .required('O perfil é obrigatório'),
        };

        // Adiciona validação para campos da aba de conexão apenas se tiver ID
        const connectionSchema = id
          ? {
              host: Yup.string()
                .required('O host/endereço é obrigatório')
                .max(
                  100,
                  'O host/endereço não pode ter mais de 100 caracteres',
                ),
              database: Yup.string()
                .required('O nome/caminho da base de dados é obrigatório')
                .max(
                  500,
                  'O nome/caminho da base de dados não pode ter mais de 500 caracteres',
                ),
              username: Yup.string()
                .required('O username é obrigatório')
                .max(100, 'O username não pode ter mais de 100 caracteres'),
              password: Yup.string()
                .required('O password é obrigatório')
                .max(100, 'O password não pode ter mais de 100 caracteres'),
            }
          : {};

        const schema = Yup.object().shape({
          ...baseSchema,
          ...connectionSchema,
        });

        await schema.validate(mergedData, {
          abortEarly: false,
        });

        if (id) {
          await api.put(`/admin/account/${id}`, mergedData);
          history.push(`/admin/accounts/cadastro/${id}`);
        } else {
          const response = await api.post('/admin/account', mergedData);
          history.push(`/admin/accounts/cadastro/${response.data.id}`);
        }

        if (mounted.current) {
          addToast({
            type: 'success',
            title: 'Sucesso!',
            description: 'Cliente salvo com sucesso',
          });
        }
      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRef.current?.setErrors(errors);
          return;
        }

        if (err.response.data) {
          if (err.response.data.error) {
            const erros = Object.keys(err.response.data.error);

            erros.map(erro =>
              addToast({
                type: 'error',
                title: 'Erro no cadastro',
                description: err.response.data.error[erro],
              }),
            );
          } else {
            addToast({
              type: 'error',
              title: 'Erro no cadastro',
              description: err.response.data,
            });
          }
        }
      } finally {
        setIsLoading(false);
        setLoadingMessage('');
      }
    },
    [addToast, history, id, formData],
  );

  // Adiciona um manipulador para rastrear alterações nos campos do formulário
  const handleFieldChange = useCallback((field: string, value: any) => {
    setFormData(prevData => {
      const newData = { ...prevData, [field]: value };

      // If the form ref exists, update the form field directly
      if (formRef.current) {
        const currentData = formRef.current.getData();
        formRef.current.setData({ ...currentData, [field]: value });
      }

      return newData;
    });
  }, []);

  const renderFormCadastro = () => {
    return (
      <>
        <HeaderCadastro>
          <div>
            <h1>{id ? 'EDITAR CLIENTE' : 'NOVO CLIENTE'}</h1>
          </div>
          <div>
            <span>Os campos com * são obrigatórios</span>
          </div>
        </HeaderCadastro>

        <BodyCadastro>
          <ContainerdadosGerais>
            <Grid
              container
              spacing={1}
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Select
                  label="Status"
                  isSearchable={false}
                  options={status}
                  name="ativo"
                  defaultValue={
                    status.find(s => s.value === formData.ativo) || status[0]
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Select
                  label="Sincronização"
                  isSearchable={false}
                  options={status}
                  name="sincronizar"
                  defaultValue={
                    status.find(s => s.value === formData.sincronizar) ||
                    status[0]
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Select
                  label="Perfil"
                  isSearchable={false}
                  options={profiles_types}
                  name="profile"
                  defaultValue={
                    profiles_types.find(p => p.value === formData.profile) ||
                    profiles_types[1]
                  }
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Select
                  label="Notificar falta de sincronização por email"
                  isSearchable={false}
                  options={status}
                  name="notificar_falha_sincronizacao"
                  defaultValue={
                    status.find(
                      s => s.value === formData.notificar_falha_sincronizacao,
                    ) || status[1]
                  }
                />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Nome da empresa*"
                name="nome"
                maxLength={100}
                placeholder="Informe o nome da empresa"
                defaultValue={formData.nome}
                onChange={e => handleFieldChange('nome', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Número máximo de usuários ativos*"
                name="max_users"
                maxLength={10}
                type="number"
                placeholder="Informe o número máximo de usuários ativos"
                defaultValue={formData.max_users}
                onChange={e => handleFieldChange('max_users', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Contract token*"
                name="contract_token"
                maxLength={255}
                placeholder="Informe o token"
                showPasswordIcon
                type="password"
                defaultValue={formData.contract_token}
                onChange={e =>
                  handleFieldChange('contract_token', e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Dias Previsão Estoque"
                name="dias_previsao_estoque"
                type="number"
                placeholder="Informe os dias de previsão de estoque"
                defaultValue={
                  formData.dias_previsao_estoque !== null &&
                  formData.dias_previsao_estoque !== undefined
                    ? formData.dias_previsao_estoque
                    : ''
                }
                onChange={e =>
                  handleFieldChange(
                    'dias_previsao_estoque',
                    e.target.value && e.target.value !== ''
                      ? parseInt(e.target.value, 10)
                      : null,
                  )
                }
              />
              <ObservacaoTexto>
                Campo válido somente para sincronização via API BeerSales
              </ObservacaoTexto>
            </Grid>
          </ContainerdadosGerais>
        </BodyCadastro>
      </>
    );
  };

  const renderDadosConexao = () => {
    // Garante que tipoSincronizacao está sincronizado
    let currentTipoSincronizacao: TipoSincronizacao = tipo_sincronizacao[0]
      .value as TipoSincronizacao;

    if (
      tipoSincronizacao === 'api_beersales' ||
      tipoSincronizacao === 'sync4'
    ) {
      currentTipoSincronizacao = tipoSincronizacao;
    } else if (
      formData.tipo_sincronizacao === 'api_beersales' ||
      formData.tipo_sincronizacao === 'sync4'
    ) {
      currentTipoSincronizacao =
        formData.tipo_sincronizacao as TipoSincronizacao;
    }

    return (
      <>
        <HeaderCadastro>
          <div>
            <h1>DADOS DE CONEXÃO</h1>
          </div>
          <div>
            <span>Os campos com * são obrigatórios</span>
          </div>
        </HeaderCadastro>

        <BodyCadastro>
          <ContainerBaseDados>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Select
                label="Conectar via"
                isSearchable={false}
                options={tipo_sincronizacao}
                name="tipo_sincronizacao"
                defaultValue={
                  tipo_sincronizacao.find(
                    t => t.value === formData.tipo_sincronizacao,
                  ) || tipo_sincronizacao[0]
                }
                onChange={selectedOption => {
                  if (selectedOption) {
                    setTipoSincronizacao(selectedOption.value);
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Host*"
                name="host"
                maxLength={100}
                placeholder="Ex.: 192.168.1.111"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Database*"
                name="database"
                maxLength={500}
                placeholder="Ex.: /var/www/database/exemplo.fdb"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Username*"
                name="username"
                maxLength={100}
                placeholder="Informe o nome de usuário"
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Input
                label="Password*"
                name="password"
                showPasswordIcon
                type="password"
                maxLength={100}
                placeholder="Informe a senha"
              />
            </Grid>

            {currentTipoSincronizacao === 'api_beersales' && id && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <OAuthConnector
                  accountId={id}
                  isConnected={formData.conectado_api || false}
                  onConnectionChange={isConnected => {
                    // First, get all current form data to preserve it
                    const currentFormData = formRef.current?.getData() || {};

                    // Update the form data state with all current values plus the new connection state
                    setFormData(prevData => ({
                      ...prevData,
                      ...currentFormData,
                      conectado_api: isConnected,
                    }));

                    // Ensure the form is updated with the current values
                    if (formRef.current) {
                      formRef.current.setData({
                        ...currentFormData,
                        conectado_api: isConnected,
                      });
                    }
                  }}
                />
              </Grid>
            )}
          </ContainerBaseDados>
        </BodyCadastro>
      </>
    );
  };

  const renderPermissoesUsuariosEmpresas = () => {
    return (
      <>
        <HeaderCadastro>
          <div>
            <h1>PERMISSÕES DE USUÁRIO POR EMPRESAS</h1>
          </div>
        </HeaderCadastro>
        <Usuarios
          total_usuarios_contratados={total_usuarios_contratados}
          usuarios={usuarios}
          empresas={empresas}
          setUsuarios={setUsuarios}
          account_id={Number(id)}
        />
      </>
    );
  };

  const renderSincronizacao = () => {
    return (
      <>
        <HeaderCadastro>
          <div>
            <h1>SINCRONIZAÇÃO POR ENTIDADE</h1>
          </div>
        </HeaderCadastro>
        <SincronizacaoEntidades accountId={Number(id)} />
      </>
    );
  };

  return (
    <Container>
      <Loading isLoading={isLoading} />
      <Voltar>
        <Link
          to="/admin/accounts/lista"
          title="Voltar para a listagem de clientes"
        >
          <UndoIcon fontSize="large" />
        </Link>
      </Voltar>

      <Box mb={2}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="Cadastro" />
          {id && <Tab label="Dados de Conexão" />}
          {id && <Tab label="Usuários" />}
          {id && mostrarSincronizacao && <Tab label="Sincronização" />}
        </Tabs>
      </Box>

      <FormContainer
        ref={formRef}
        onSubmit={handleSubmit}
        initialData={formData}
      >
        {tabIndex === 0 && renderFormCadastro()}
        {tabIndex === 1 && id && renderDadosConexao()}
        {tabIndex !== 2 && tabIndex !== ABA_SINCRONIZACAO && (
          <FooterCadastro>
            <BotaoSalvar loading={loading_message} type="submit">
              Salvar
            </BotaoSalvar>
          </FooterCadastro>
        )}
      </FormContainer>
      {tabIndex === 2 && id && renderPermissoesUsuariosEmpresas()}
      {tabIndex === ABA_SINCRONIZACAO &&
        id &&
        mostrarSincronizacao &&
        renderSincronizacao()}
    </Container>
  );
};

export default CadastroAccounts;
